import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "@/components/legal/legal-document-page";

export const Route = createFileRoute("/privacidade")({
  head: () => ({
    meta: [
      { title: "Innovally — Política de Privacidade" },
      {
        name: "description",
        content:
          "Saiba como a Innovally trata dados pessoais de lojistas, sublojistas e motoboys, em conformidade com a LGPD.",
      },
      { property: "og:title", content: "Innovally — Política de Privacidade" },
      {
        property: "og:description",
        content:
          "Como a Innovally coleta, usa e protege dados pessoais no aplicativo e na plataforma.",
      },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <LegalDocumentPage documentId="privacy" />,
});
